import type { PortEnv } from '../../port-contract';
import { slot, values, type Arr } from './access';
import { numericNextSpellCarriers, type NextSpellCarrierDeps } from './next_spell_numeric_carriers';
/** PHP: ft_sanguine_counterspell_against_dis_carriers (includes/functions/janus/core/sanguine_counterspell_dis.php:30) */
export function ftSanguineCounterspellAgainstDisCarriers(caster: Arr, env: PortEnv<NextSpellCarrierDeps>): Arr {
    return numericNextSpellCarriers(caster, 'counterspell_against_dis', 'dis', 1, env, false);
}
/** PHP: ft_sanguine_counterspell_against_dis_total (includes/functions/janus/core/sanguine_counterspell_dis.php:67) */
export function ftSanguineCounterspellAgainstDisTotal(caster: Arr, env: PortEnv<NextSpellCarrierDeps>): number {
    let total = 0;
    for (const carrier of values(ftSanguineCounterspellAgainstDisCarriers(caster, env))) total += Number(slot(carrier, 'dis'));
    return Math.max(0, Math.min(5, total));
}
